import type { BuildingSocietyFeatures } from './type';

export const buildingSociety: BuildingSocietyFeatures = {
    buildingSociety: {
        enabled: true,
        _description: 'Enables the whole building society product including loading, main display',
    },
    buildingSocietyServicing: {
        enabled: true,
        _description:
            'Enables the building society advanced ticketing which is the advanced api connected selfservicing',
    },
};
